import { Seller } from "./type";


export function mapSellerToSelectOptions(seller: Seller[]) {
    return seller.map((seller) => {
        return {
            select: seller.name,
            cpf: seller.cpf,
            value: seller.id,
        }
    })
}

export function generateLinkCatalog(sellerId: number, sellers: Seller[]) {
    try {
        /* Agora podemos usar tanto o codigo quanto o cpf para fazer o link, por padrao vamos usar o codigo */
        const sellerFind = sellers.find((seller) => seller.id === sellerId)

        if (sellerFind) {
            const useCode = sellerFind.sellerCode ? true : false
            const value = useCode ? sellerFind.sellerCode : sellerFind.cpf
            const encodedValue = useCode ? window.btoa(`{code: ${value}}`) : window.btoa(`{cpf: ${value}}`)
            return `?vendor=${encodedValue}`
        }
    } catch (error) {
        console.error('Erro ao gerar link do catálogo:', error)
    }
    return ''
}